import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.7279 32.7279C29.3523 36.1036 24.7739 38 20 38C15.2261 38 10.6477 36.1036 7.27208 32.7279C3.89642 29.3523 2 24.7739 2 20C2 15.2261 3.89642 10.6477 7.27208 7.27208C10.6477 3.89642 15.2261 2 20 2C24.7739 2 29.3523 3.89642 32.7279 7.27208C36.1036 10.6477 38 15.2261 38 20C38 24.7739 36.1036 29.3523 32.7279 32.7279ZM27.846 14.3399C28.4513 13.7346 28.4513 12.7593 27.846 12.154C27.2407 11.5487 26.2653 11.5487 25.6601 12.154L20 17.8141L14.3398 12.154C13.7346 11.5487 12.7592 11.5487 12.1539 12.154C11.5486 12.7593 11.5486 13.7346 12.1539 14.3399L17.814 20L12.1539 25.6601C11.5486 26.2654 11.5486 27.2408 12.1539 27.846C12.7592 28.4513 13.7346 28.4513 14.3398 27.846L20 22.1859L25.6601 27.846C26.2653 28.4513 27.2407 28.4513 27.846 27.846C28.4513 27.2408 28.4513 26.2654 27.846 25.6601L22.1859 20L27.846 14.3399Z"
	})
});
export default SvgCloseCircle;
